import {StreamDataServer} from '../sse/streamDataServer';
export const DefaultStreamDataServer = new StreamDataServer('https', 'streamdata.motwin.net');


// WEBPACK FOOTER //
// ../~/tslint-loader!./configuration/config.ts